"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var routes = {
  '/blog': {
    title: 'Blog',
    view: 'Articles',
    "public": true,
    locales: {
      az: '/az/blog',
      en: '/en/blog',
      ru: '/ru/blog'
    }
  },
  '/az/blog': {
    ref: '/blog',
    lang: 'az',
    title: 'Bloq'
  },
  '/en/blog': {
    ref: '/blog',
    lang: 'en',
    title: 'Blog'
  },
  '/ru/blog': {
    ref: '/blog',
    lang: 'ru',
    title: 'Блог'
  }
};
var _default = exports["default"] = routes;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJyb3V0ZXMiLCJ0aXRsZSIsInZpZXciLCJsb2NhbGVzIiwiYXoiLCJlbiIsInJ1IiwicmVmIiwibGFuZyIsIl9kZWZhdWx0IiwiZXhwb3J0cyJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL2xpYnJhcnkvc3JjLWNsaWVudC9tb2R1bGVzL0NvbnRlbnQvQXJ0aWNsZS9BcnRpY2xlUm91dGVzLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImNvbnN0IHJvdXRlcyA9IHtcblx0Jy9ibG9nJzoge1xuXHRcdHRpdGxlOiAnQmxvZycsXG5cdFx0dmlldzogJ0FydGljbGVzJyxcblx0XHRwdWJsaWM6IHRydWUsXG5cdFx0bG9jYWxlczoge1xuXHRcdFx0YXo6ICcvYXovYmxvZycsXG5cdFx0XHRlbjogJy9lbi9ibG9nJyxcblx0XHRcdHJ1OiAnL3J1L2Jsb2cnLFxuXHRcdH1cblx0fSxcblx0Jy9hei9ibG9nJzoge3JlZjogJy9ibG9nJywgbGFuZzogJ2F6JywgdGl0bGU6ICdCbG9xJ30sXG5cdCcvZW4vYmxvZyc6IHtyZWY6ICcvYmxvZycsIGxhbmc6ICdlbicsIHRpdGxlOiAnQmxvZyd9LFxuXHQnL3J1L2Jsb2cnOiB7cmVmOiAnL2Jsb2cnLCBsYW5nOiAncnUnLCB0aXRsZTogJ9CR0LvQvtCzJ30sXG59O1xuXG5leHBvcnQgZGVmYXVsdCByb3V0ZXM7XG4iXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLElBQU1BLE1BQU0sR0FBRztFQUNkLE9BQU8sRUFBRTtJQUNSQyxLQUFLLEVBQUUsTUFBTTtJQUNiQyxJQUFJLEVBQUUsVUFBVTtJQUNoQixVQUFRLElBQUk7SUFDWkMsT0FBTyxFQUFFO01BQ1JDLEVBQUUsRUFBRSxVQUFVO01BQ2RDLEVBQUUsRUFBRSxVQUFVO01BQ2RDLEVBQUUsRUFBRTtJQUNMO0VBQ0QsQ0FBQztFQUNELFVBQVUsRUFBRTtJQUFDQyxHQUFHLEVBQUUsT0FBTztJQUFFQyxJQUFJLEVBQUUsSUFBSTtJQUFFUCxLQUFLLEVBQUU7RUFBTSxDQUFDO0VBQ3JELFVBQVUsRUFBRTtJQUFDTSxHQUFHLEVBQUUsT0FBTztJQUFFQyxJQUFJLEVBQUUsSUFBSTtJQUFFUCxLQUFLLEVBQUU7RUFBTSxDQUFDO0VBQ3JELFVBQVUsRUFBRTtJQUFDTSxHQUFHLEVBQUUsT0FBTztJQUFFQyxJQUFJLEVBQUUsSUFBSTtJQUFFUCxLQUFLLEVBQUU7RUFBTTtBQUNyRCxDQUFDO0FBQUMsSUFBQVEsUUFBQSxHQUFBQyxPQUFBLGNBRWFWLE1BQU0iLCJpZ25vcmVMaXN0IjpbXX0=